import { Separator } from "@shared/ui/separator";
import { Card, CardContent, CardHeader } from "@shared/ui/card";
import { FormattedMessage, useIntl } from "react-intl";
import { Button } from "@shared/ui/button";
import { env } from "@shared/config/env";
import ProfileHeader from "@features/profile/components/profile-header";

const rows = [
	{ label: "Name", value: env.VITE_PROJECT_NAME },
	{ label: "Version", value: "1.0.0" },
	{ label: "Build", value: "2026.04.29" },
	{ label: "Environment", value: "production" },
];

export default function AboutApp() {
	const intl = useIntl();
	return (
		<div className="space-y-6">
			<ProfileHeader
				title={intl.formatMessage({
					id: "page.profile.about-app.title",
					defaultMessage: "About the application",
				})}
				description={intl.formatMessage({
					id: "page.profile.about-app.description",
					defaultMessage: "Information about the current version and build.",
				})}
			/>
			<Card>
				<CardContent className="pt-6">
					<dl className="divide-y">
						{rows.map((r) => (
							<div
								key={r.label}
								className="flex items-center justify-between py-3 first:pt-0 last:pb-0"
							>
								<dt className="text-sm text-muted-foreground">{r.label}</dt>
								<dd className="text-sm font-medium">{r.value}</dd>
							</div>
						))}
					</dl>
				</CardContent>
			</Card>
			<Card>
				<CardHeader>
					<h2 className="text-lg font-semibold tracking-tight">
						<FormattedMessage
							defaultMessage="Legal information"
							id="page.profile.about-app.legal-information.title"
						/>
					</h2>
					<p className="text-sm text-muted-foreground">
						<FormattedMessage
							defaultMessage="Documents and links."
							id="page.profile.about-app.legal-information.description"
						/>
					</p>
				</CardHeader>

				<CardContent>
					<div className="flex flex-col gap-3 sm:flex-row">
						<Button variant="outline">
							<FormattedMessage
								defaultMessage="Terms of use"
								id="page.profile.about-app.legal-information.terms-of-use"
							/>
						</Button>
						<Button variant="outline">
							<FormattedMessage
								defaultMessage="Privacy policy"
								id="page.profile.about-app.legal-information.privacy-policy"
							/>
						</Button>
					</div>
					<Separator className="my-6" />
					<p className="text-sm text-muted-foreground">
						<FormattedMessage
							defaultMessage="© {year} Lovable. All rights reserved."
							id="page.profile.about-app.legal-information.copyright"
							values={{ year: new Date().getFullYear() }}
						/>
					</p>
				</CardContent>
			</Card>
		</div>
	);
}
